<template>
    <div class="header-nav-section">
        <div class="container header-container">
            <div class="nav-mobile" for="menu-btn">
                <label class="btn menu-btn" @click="showDrawer">
                    <i class="fas fa-bars"></i></label>
            </div>
            <div class="main-menu-wrapper">
                <a-menu mode="horizontal" class="main-menu" v-show="!isSearch">
                    <a-menu-item v-for="item in dataMenu" :key="item.id" @mouseenter="onMouseEnter(item)"
                        @mouseleave="onMouseLeave(item)" class="menu-header">
                        <span class="menu-title">
                            <router-link :to="item.linkTo" class="nav-link">
                                <span class="icon-menu" v-if="item.icon != null && item.icon.length > 0"><i
                                        :class="item.icon"></i></span>
                                <span>{{ $t(item.linkLabel) }} {{ item.name }}</span>
                            </router-link>
                            <!-- <router-link :to="item.linkTo" class="nav-link" v-else>
                                <span class="icon-menu" v-if="item.icon != null && item.icon.length > 0"><i
                                        :class="item.icon"></i></span>
                                <span>{{ $t(item.linkLabel) }} {{ item.linkTo }}</span>
                            </router-link> -->
                        </span>
                    </a-menu-item>
                </a-menu>
                <div v-show="isSearch" class="search-header">
                    <!-- <a-input-search v-model:value="value" placeholder="input search text" enter-button
                        @search="onSearch" /> -->
                    <a-input-search size="large" v-model:value="searchValue"
                        placeholder="input search loading with enterButton" enter-button />

                </div>

                <div v-if="showMegaMenu" class="mega-menu" @mouseenter="handleMegaMenuEnter"
                    @mouseleave="handleMegaMenuLeave">
                    <MegaMenu :megaMenu="megaMenu"></MegaMenu>
                </div>
            </div>
            <div class="header-icons">

                <SearchOutlined class="icon" @click="isSearch = !isSearch" />
                <a-badge :count="cartCount" :number-style="{ backgroundColor: '#b19663' }" size="small">
                    <a-dropdown>
                        <span>
                            <ShoppingCartOutlined class="icon" />
                        </span>
                        <template #overlay>
                            <CartMenu></CartMenu>
                        </template>
                    </a-dropdown>
                    <!-- <span class="cart-count-text">{{ cartCount }}</span> -->
                </a-badge>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { HeartOutlined, UserOutlined, SearchOutlined, ShoppingCartOutlined } from '@ant-design/icons-vue'
import { MENU_HEADER_TOP1_COOKIE, COMPANY_DETAIL_COOKIE } from '@/const/ConstCookies'
import { V1_REDIS_GET_KEY } from "@/api/const/redis";
import { apiPost, apiGetNoParam, apiGet } from "@/api/index";
import commons from "@/utils/Common";
import MegaMenu from "@/components/Headers/default/menu/MegaMenu.vue"
import CartMenu from "@/views/client/cart/CartMenu.vue"
import store from '@/store';
const emits = defineEmits(["openMenuMobile"])
const router = useRouter()
const isSearch = ref(false)
const searchValue = ref('')

const cartCount = ref(0)
const showMegaMenu = ref(false)
const menuHeader: any = ref([]);
const megaMenu: any = ref([]);


interface Props {
  dataMenu: any[]
}

const props = withDefaults(defineProps<Props>(), {
  dataMenu: () => []
})

onMounted(async () => {
    // await loadMenuHeaderTop();
    getCart()
});

const loadMenuHeaderTop = async () => {
    await apiGetNoParam(
        V1_REDIS_GET_KEY + "?key=menu-top-header"
    ).then((res) => {
        let response: any = res;
        let data = response.data.data
        commons.setLocalStorage(MENU_HEADER_TOP1_COOKIE, data)
        let menuTop = JSON.parse(commons.getLocalStorage(MENU_HEADER_TOP1_COOKIE) || 'null')
        menuHeader.value = menuTop;
    });

}
const getCart = () => {
    loadCart()
}
const showDrawer = () => {
    emits('openMenuMobile')
}

let hoverTimeout: any = null
const onMouseEnter = (item: any) => {
    if (hoverTimeout) clearTimeout(hoverTimeout)
    if (item.menuClass === 'megaMenu') {
        console.log('megaMenu', item)
        megaMenu.value = item.children
        showMegaMenu.value = true
    } else {
        showMegaMenu.value = false
    }
}

const onMouseLeave = (item: any) => {
    if (item.menuClass === 'megaMenu') {
        hoverTimeout = setTimeout(() => {
            showMegaMenu.value = false
        }, 150)
    }
}

const loadCart = () => {
    let dataList = commons.getLcCartObject();
    cartCount.value = dataList.orderList.length || 0
};

const isLoadCart = computed(() => {
    return store.getters.isLoadCart;
});
watch(isLoadCart, async (newValue, oldValue) => {
    await loadCart();
});

const handleMegaMenuEnter = () => {
    if (hoverTimeout) {
        clearTimeout(hoverTimeout)
    }
    showMegaMenu.value = true
}

const handleMegaMenuLeave = () => {
    hoverTimeout = setTimeout(() => {
        showMegaMenu.value = false
    }, 150)
}
</script>
<style lang="css" scoped>
/* =======================
   HEADER
======================= */
.search-header {
    margin: 0 50px;
    border-radius: 5px;
    background: #b19663 !important;
    background-color: #b19663 !important;
}

.icon-menu i {
    font-size: 16px !important;
}

.header-nav-section {
    background: #102542;
    /* background: #fff;
  border-bottom: 1px solid var(--border-light); */
    position: relative;
    z-index: 100;
    /* width: 100%; */
    overflow: visible !important;
    /* QUAN TRỌNG */
}

.header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    overflow: visible !important;
    /* QUAN TRỌNG */
}

/* =======================
   MENU
======================= */

.main-menu-wrapper {
    position: relative;
    flex: 1;
}

/* Ant Design Menu override */
.main-menu {
    border-bottom: none !important;
    background: transparent !important;
}

.main-menu .ant-menu-item,
.main-menu .ant-menu-submenu-title {
    font-weight: 600;
    letter-spacing: 1px;
    color: #b19663;
    padding: 0 20px;
}

.main-menu .ant-menu-item:hover,
.main-menu .ant-menu-submenu-title:hover,
.header-icons .icon,
.cart-count-text {
    color: #b19663 !important;
}

/* =======================
   MEGA MENU
======================= */

.mega-menu {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-48%);
    width: 100vw;
    z-index: 9999;
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

/* =======================
   VIEW ALL
======================= */

.view-all-wrapper {
    margin-top: 20px;
}

.view-all {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 1px;
    color: var(--primary-gold);
    text-decoration: none;
}

/* =======================
   IMAGE CARD
======================= */

.mega-image-card {
    cursor: pointer;
}

.image-wrapper {
    width: 100%;
    height: 180px;
    /* overflow: hidden; */
}

.image-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
}

.mega-image-card:hover img {
    transform: scale(1.05);
}

.image-label {
    margin-top: 10px;
    font-weight: 600;
    letter-spacing: 1px;
    font-size: 14px;
    color: var(--text-dark);
}

/* =======================
   HEADER ICONS
======================= */

.header-icons {
    display: flex;
    align-items: center;
    gap: 20px;
}

.header-icons .icon {
    font-size: 20px;
    cursor: pointer;
    color: var(--text-dark);
    transition: color 0.2s ease;
}

.header-icons .icon:hover {
    color: var(--primary-gold);
}

/* =======================
   RESPONSIVE
======================= */

@media (max-width: 1024px) {
    .mega-menu {
        display: none;
    }
}

.menu-header {
    text-transform: uppercase;
}
</style>